// extracted by css-extract-rspack-plugin
export default {"fileControlWrapper":"src-domain-styles-file-preview-truncate-module__fileControlWrapper-aaLbJw"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"fileControlWrapper\":\"src-domain-styles-file-preview-truncate-module__fileControlWrapper-aaLbJw\"}";
        // 1793705032592
        var cssReload = require("../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  